import React from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineDot from "@mui/lab/TimelineDot";
import GlobalTheme from "../../../styles/global.theme";
import { TimelineLogo } from "../../../CompanyForm.styled";
import logo from "../../../images/Logo-white.svg";
import { StyledTimelineContent } from "../../../MUIStyled";
import { useLocation } from "react-router-dom";

export default function CustomTimeline({ currentStep }) {
  const location = useLocation();
  const isThankYouPage = location.pathname === "/thank-you";
  const purpleStyles = {
    backgroundColor: GlobalTheme.palette.purple.primary.disabled,
    color: GlobalTheme.palette.purple.primary.disabled,
  };

  const getTimelineConnectorColor = (step) => {
    if (isThankYouPage) {
      return purpleStyles.color;
    }
    return step < currentStep
      ? GlobalTheme.palette.white.primary.main
      : GlobalTheme.palette.purple.primary.disabled;
  };
  const getTimelineDotColor = (step) => {
    if (isThankYouPage) {
      return {
        backgroundColor: "transparent",
        border: `3px solid ${purpleStyles.color}`,
        width: "36px",
        height: "24px",
      };
    }
    return currentStep >= step
      ? {
          backgroundColor: GlobalTheme.palette.white.primary.main,
          color: GlobalTheme.palette.white.primary.main,
        }
      : {
          backgroundColor: "transparent",
          border: `3px solid ${purpleStyles.color}`,
        };
  };
  const getTimelineContentColor = (step) => {
    if (isThankYouPage) {
      return {
        backgroundColor: "transparent",
        color: purpleStyles.color,
      };
    }

    return currentStep >= step
      ? {
          backgroundColor: GlobalTheme.palette.white.primary.main,
          color: GlobalTheme.palette.white.primary.main,
        }
      : {
          backgroundColor: "transparent",
          color: GlobalTheme.palette.purple.primary.disabled,
        };
  };

  return (
    <Timeline
      sx={{
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          marginBottom: 10,
        },
      }}
    >
      <div style={{ marginBottom: "20px" }}>
        <TimelineLogo src={logo} alt="Logo" />
      </div>

      {[1, 2, 3, 4, 5, 6].map((step, index) => (
        <TimelineItem key={step}>
          <TimelineSeparator>
            <TimelineDot
              sx={{
                backgroundColor: getTimelineDotColor(step),
                width: "15px",
                height: "15px",
                borderRadius: "50%",
              }}
            />
            {index !== 5 && (
              <TimelineConnector
                sx={{
                  backgroundColor: getTimelineConnectorColor(step),
                }}
              />
            )}
          </TimelineSeparator>
          <StyledTimelineContent
            sx={{
              color: getTimelineContentColor(step).color,
            }}
          >
            {
              [
                "Company details",
                "Company addresses",
                "Contact details",
                "Payroll deductions, invoicing & employer obligations",
                "Payment information",
                "Review company details",
              ][step - 1]
            }
          </StyledTimelineContent>
        </TimelineItem>
      ))}
    </Timeline>
  );
}
